import { render, staticRenderFns } from "./MoreSettings.vue?vue&type=template&id=3d3c1e18&scoped=true&"
import script from "./MoreSettings.vue?vue&type=script&lang=js&"
export * from "./MoreSettings.vue?vue&type=script&lang=js&"
import style0 from "./MoreSettings.vue?vue&type=style&index=0&id=3d3c1e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c1e18",
  null
  
)

export default component.exports